import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

interface OpacitySliderProps {
  opacity: number; // 0..1
  onChange: (opacity: number) => void;
  onClose: () => void;
}

/**
 * Floating opacity slider rendered over the tooth chart stage when an
 * image overlay is active.
 */
export function OpacitySlider({ opacity, onChange, onClose }: OpacitySliderProps) {
  const { t } = useTranslation();
  const pct = Math.round(opacity * 100);

  return (
    <div className="absolute bottom-4 right-4 z-20 flex items-center gap-3 rounded-xl border border-ds-line bg-ds-card/95 px-4 py-2.5 shadow-pop backdrop-blur-sm">
      <span className="text-xs font-medium text-ds-muted">
        {t('dental.imaging.overlay.opacity')}
      </span>
      <input
        type="range"
        min={0}
        max={100}
        value={pct}
        onChange={(e) => onChange(Number(e.target.value) / 100)}
        className="h-1.5 w-28 cursor-pointer accent-ds-teal"
      />
      <span className="w-10 text-right text-xs font-mono text-ds-muted">
        {pct}%
      </span>
      <button
        onClick={onClose}
        title={t('dental.imaging.overlay.hide')}
        className="ml-1 rounded-md p-1 text-ds-muted hover:bg-ds-neutral-tint hover:text-ds-text hover:bg-ds-sunk"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
